import { render } from "./MicroLearning.vue?vue&type=template&id=e016a4fe&scoped=true"
import script from "./MicroLearning.vue?vue&type=script&lang=js"
export * from "./MicroLearning.vue?vue&type=script&lang=js"

import "./MicroLearning.vue?vue&type=style&index=0&id=e016a4fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e016a4fe"]])

export default __exports__